import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const VillaAirePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReserveClick = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const reserveSection = document.getElementById('reserve');
      if (reserveSection) {
        reserveSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const images = [
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/040bd9a288abf18842636ea8845df332.jpeg',
      alt: 'Villa Aire - Elegant white building with colorful trim'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/8e9919762c6b54568803ef610e925a09.jpeg',
      alt: 'Villa Aire interior space with modern design'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/def956a2d9af75fcf718c1bc3383355d.jpeg',
      alt: 'Villa Aire interior living space with leaf wall art'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/98c1d68bf33c71fa868c62e602e484ca.jpeg',
      alt: 'Villa Aire bedroom with artistic wall mural'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/bdb2ab0edc10f78d89b5770ac2263105.jpeg',
      alt: 'Villa Aire bright bedroom with white furniture'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/c4e00dc81cd39addaa1f38e46dcefe50.jpeg',
      alt: 'Villa Aire bedroom with elegant decor'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/a1d74edb97571611427b470a9becd36a.jpeg',
      alt: 'Villa Aire bedroom with twin beds and blue accents'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/c96bc5552575c974dfe25783fda8eac4.jpeg',
      alt: 'Villa Aire outdoor terrace with pool and palm trees'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative h-[60vh] min-h-[500px]">
          <img
            src={images[0].url}
            alt={images[0].alt}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 w-full">
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">
                Villa Aire
              </h1>
              <p className="text-xl text-white/90 max-w-2xl">
                Airy and spacious, perfect for those seeking lightness and clarity. 
                Features open terraces and abundant natural light.
              </p>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6">
                  About Villa Aire
                </h2>
                <div className="prose prose-lg text-gray-600 space-y-4">
                  <p>
                    Villa Aire embodies the lightness and freedom of the air element. This beautiful 
                    sanctuary features open spaces, abundant natural light, and airy design elements 
                    that create a sense of clarity and expansiveness.
                  </p>
                  <p>
                    The villa's design celebrates openness and flow, with spacious terraces, high 
                    ceilings, and large windows that invite the sky and breeze inside. Every detail 
                    has been thoughtfully chosen to support your journey of mental clarity and 
                    spiritual elevation.
                  </p>
                  <p>
                    Perfect for those seeking mental clarity, inspiration, and a sense of freedom, 
                    Villa Aire offers a light-filled retreat where you can truly breathe and expand 
                    your horizons.
                  </p>
                </div>
              </div>

              <div className="bg-sand-50 rounded-2xl p-8">
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6">
                  Villa Details
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-user-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Capacity</div>
                      <div className="text-gray-600">Sleeps 2-4 guests</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-hotel-bed-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bedrooms</div>
                      <div className="text-gray-600">2 bedrooms</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shower-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bathrooms</div>
                      <div className="text-gray-600">2 full bathrooms</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-sun-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Outdoor Space</div>
                      <div className="text-gray-600">Open terraces with panoramic views</div>
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleReserveClick}
                  className="w-full mt-8 bg-primary-500 hover:bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Reserve Villa Aire
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Photo Gallery */}
        <section className="py-16 bg-sand-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Photo Gallery
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {images.map((image, index) => (
                <div 
                  key={index}
                  className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer"
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Amenities Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Amenities
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-wifi-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">High-Speed WiFi</h3>
                <p className="text-sm text-gray-600">Stay connected throughout your stay</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-temp-cold-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Air Conditioning</h3>
                <p className="text-sm text-gray-600">Climate control in all rooms</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-restaurant-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Full Kitchen</h3>
                <p className="text-sm text-gray-600">Fully equipped for meal preparation</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-parking-box-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Free Parking</h3>
                <p className="text-sm text-gray-600">Complimentary on-site parking</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-service-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Daily Housekeeping</h3>
                <p className="text-sm text-gray-600">Keep your space fresh and clean</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-cake-2-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Organic Breakfast</h3>
                <p className="text-sm text-gray-600">Healthy breakfast included daily</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-sun-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Open Terraces</h3>
                <p className="text-sm text-gray-600">Spacious outdoor areas with views</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-yoga-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Yoga Space Access</h3>
                <p className="text-sm text-gray-600">Shared yoga and meditation areas</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-primary-50 to-sand-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">
              Ready to Experience Villa Aire?
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Limited spots available for our upcoming retreats. Reserve your place in this 
              light-filled sanctuary and begin your journey of clarity and expansion.
            </p>
            <button
              onClick={handleReserveClick}
              className="bg-primary-500 hover:bg-primary-600 text-white px-12 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Reserve Your Spot
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default VillaAirePage;